export const Title = 'Appointment Booking';
export const Description = 'Syncs with your PMS to display real-time appointment availability, allowing patients to select a date and time to book and appointment with you.';
